import { render, staticRenderFns } from "./ActivitiesList.vue?vue&type=template&id=35d28638&"
import script from "./ActivitiesList.vue?vue&type=script&lang=js&"
export * from "./ActivitiesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QChip,QResizeObserver} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QChip,QResizeObserver})
